export default __webpack_public_path__ + "static/media/gradients-3.2cbcae12.png";